const LOAD_DETAIL_JOB_POSTING_TYPE           = 'LOAD_DETAIL_JOB_POSTING_TYPE'
const LOAD_DETAIL_JOB_POSTING_TYPE_SUCCESS   = 'LOAD_DETAIL_JOB_POSTING_TYPE_SUCCESS'
const LOAD_DETAIL_JOB_POSTING_TYPE_FAILED    = 'LOAD_DETAIL_JOB_POSTING_TYPE_FAILED'
const UNMOUNT_DETAIL_JOB_POSTING_TYPE        = 'UNMOUNT_DETAIL_JOB_POSTING_TYPE'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const jobPostingTypeDetailReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_JOB_POSTING_TYPE:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DETAIL_JOB_POSTING_TYPE_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DETAIL_JOB_POSTING_TYPE_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DETAIL_JOB_POSTING_TYPE:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default jobPostingTypeDetailReducer;